import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { UsageTracker, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { getAnalyticsModuleName } from 'store/navigation/navigation.ts';
import { startTimingTrackingEvent, trackNavigationEvent } from '../mixpanel/mixpanel-client';
import { ANALYTICS_TRACKING_TYPES } from '../analytics-enums';

const ConnectedUsageTracker = () => {
  const { pathname: pathName } = useLocation();
  const onStartTimingEvent = useCallback(() => startTimingTrackingEvent(ANALYTICS_TRACKING_TYPES.PAGE_VIEW), []);
  return (
    <UsageTracker
      pathName={pathName}
      moduleName={getAnalyticsModuleName(pathName)}
      onNavigate={trackNavigationEvent}
      onStartTimingEvent={onStartTimingEvent}
    />
  );
};

const ConnectedUsageTrackerWithErrorBoundary = withErrorBoundary(ConnectedUsageTracker);

export { ConnectedUsageTrackerWithErrorBoundary as UsageTracker };
